<template>
    <div id="order-windows">
      <div class="ltowindow">
        <p class="txt">您有{{length}}笔进行中的行程</p>
        <div class="select">
          <span class="course" @click="getstate(2)">我知道了</span>
          <span class="end" @click="getstate(1)">查看</span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'order-windows',
  props: {
    'length': [Number],
    'orderId': [String]
  },
  methods: {
    getstate (_num) {
      if (_num === 1) {
        if (this.length > 1) {
          this.$router.push({name: 'journeyList'})
        } else {
          this.$router.push('/appointmentinfo?no=' + this.orderId)
        }
      } else {
        this.$emit('ievent')
      }
    }
  }
}
</script>

<style scoped>
  #order-windows{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.6);
    z-index: 9999;
  }
  #order-windows .ltowindow{
    margin: 30vh 50px 0 50px;
    height: 125px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
  }
  #order-windows .ltowindow .close{
    width: 44px;
    height: 44px;
    background-color: rgba(249, 249, 249, 1);
    border-radius: 100%;
    text-align: center;
    line-height: 44px;
    box-shadow: 0 1px 6px rgba(0,0,0,0.2);
    margin: 20px auto;
    font-size: 30px;
  }
  #order-windows .ltowindow .icondui{
    margin: 20px auto;
    display: block;
    width: 44px;
    height: 44px;
  }
  #order-windows .ltowindow .txt{
    height: 80px;
    line-height: 80px;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    text-align: center;
    margin: 0 30px;
  }
  #order-windows .ltowindow .select{
    width: 100%;
    border-top: 1px solid rgba(238, 238, 238, 1);
    display: -webkit-box;
    -webkit-box-pack: justify;
  }
  #order-windows .ltowindow .select .icanplay{
    width: 100%;
    text-align: center;
    color: #23A4FF;
    font-size: 14px;
  }
  #order-windows .ltowindow .select span{
    display: block;
    width: 50%;
    text-align: center;
    height: 48px;
    line-height: 48px;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
  }
  #order-windows .ltowindow .select .end{
    color: rgba(35, 164, 255, 1);
    position: relative;
  }
  #order-windows .ltowindow .select .end:after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 48px;
    width: 1px;
    background: rgba(238, 238, 238, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/ReceptionStation/model/orderWindows.vue